// Paddle product and price IDs
// Replace these with your actual Paddle product and price IDs

// Paddle subscription constants
export const MONTHLY_PRODUCT_ID = 'pro_01jsh6chcayqr26w0nvpbzf8sc';
export const YEARLY_PRODUCT_ID = 'pro_01jsh6sdtw07w72d653dpthk8z';

// Price IDs - Kullanıcının verdiği price ID'leri
export const MONTHLY_PRICE_ID = 'pri_01jsh6fef0zevaa49xr99c25q3';
export const YEARLY_PRICE_ID = 'pri_01jsh6wb4brwkpbmqhp02kh9xb';

// Subscription IDs - Use Price IDs for checkout
export const MONTHLY_SUBSCRIPTION_ID = MONTHLY_PRICE_ID;
export const YEARLY_SUBSCRIPTION_ID = YEARLY_PRICE_ID;

// Environment
export const PADDLE_ENVIRONMENT = 'production';

// RevenueCat API Key - Use environment variable for security
export const REVENUECAT_API_KEY = import.meta.env.VITE_REVENUECAT_API_KEY || '';

// SSR-safe function to get origin
export const getOriginUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return '';
};

// Paddle checkout settings (shared between subscription types)
// Format according to Paddle.js documentation
export const PADDLE_CHECKOUT_SETTINGS = {
  theme: 'light',           // 'light' or 'dark'
  locale: 'en',             // Checkout language
  displayMode: 'overlay',   // 'overlay' or 'inline'
  frameTarget: 'paddle-checkout-container', // ID of div where inline checkout should be rendered
  // Use a function to get the origin dynamically
  get successUrl() {
    return `${getOriginUrl()}/thank-you?checkout_id={checkout_id}`;
  },
  allowLogout: false        // Whether the user can change their email once on the checkout
};

// Fallback prices if API preview fails
export const FALLBACK_PRICES = {
  [MONTHLY_PRICE_ID]: {
    gross: '$9.99',
    currency: 'USD',
    interval: 'month'
  },
  [YEARLY_PRICE_ID]: {
    gross: '$49.99',
    currency: 'USD',
    interval: 'year'
  }
}; 